module.exports = __webpack_public_path__ + "img/substrate.687af2e0.jpg";